import { ref, watchEffect } from 'vue'

import { normalizeIdentity } from '@/lib/adapters/identity.adapter'
import { handleErrorMessage } from '@/lib/helpers/error.helpers'
import { request } from '@/lib/services'
import type { IdentityFormType } from '@/lib/types/identity.types'
import { useErrorStore } from '@/stores/error'

export const useGetCreatorIdentityRequest = (id: number) => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)
  const data = ref<IdentityFormType | null>(null)
  const errorStore = useErrorStore()

  const getCreator = async () => {
    try {
      isLoading.value = true
      error.value = null
      const response = await request.get(`/users/${id}`)
      data.value = normalizeIdentity(response.data)
    } catch (e: unknown) {
      errorStore.setError(handleErrorMessage(e))
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }

  watchEffect(() => void getCreator())

  return {
    data,
    getCreator,
    isLoading,
    error,
  }
}

export const useUpdateIdentityRequest = (userId: number) => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)
  const errorStore = useErrorStore()

  const updateIdentity = async (identityData: IdentityFormType) => {
    try {
      isLoading.value = true
      error.value = null
      await request.put(`/v2/users/${userId}/identity/`, identityData)
    } catch (e: unknown) {
      errorStore.setError(handleErrorMessage(e))
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }

  return {
    updateIdentity,
    isLoading,
    error,
  }
}
